// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"_1yxr4","header":"_3Etjp","headerItem":"vvQKM","date":"_1CB_k","delete":"_2bZvb"};